<app-student-related-events *ngIf="showStudentRelatedEventsDialog$ | async" [stdentDetails]="stdentDetails"
  [isEI]="isEI" [studentSk$]="studentSk" (close)="closeStudentRelatedEventsDialog()">
</app-student-related-events>

<div class="marginTop">
  <app-dashboard [title]="gridTitle" [columnDefinitions]="columnDefinitions" [gridApiRoute]="gridApiRoute"
    [studentSk]="studentSk" [initialGridState]="initialGridState" [refershGrid]="refershGrid"
    [addButtonText]="addButtonText"  [gridHeader]="gridHeader" [permissionToView]="4" (addToGrid)="openStudentRelatedEventsDialog()">
  </app-dashboard>
</div>